import { useCallback, useEffect } from 'react';
import { useUserLevelPreference } from '@bingads-webui-campaign-react/common-hooks';

const COPILOT_PREFERENCE = 'SurveyPreference.CopilotAssetRecommendation.Features';

export const useCopilotRecommendationSurvey = (currentFeature) => {
  const [{ value: features }, { update: updateFeatures }] = useUserLevelPreference(COPILOT_PREFERENCE, []);

  useEffect(() => {
    if (!features.includes(currentFeature)) {
      updateFeatures([...features, currentFeature].sort());
    }
  }, [features, currentFeature, updateFeatures]);

  const trigger = useCallback((action) => {
    if (!window.survey || !window.survey.surveyManager) {
      return;
    }

    window.survey.CopilotAssetRecommendationSatisfactionTrigger = true;
    window.survey.CopilotRecommendationsSurveyCustomParams = { action, features };

    window.survey.surveyManager.trigger();
  }, [features]);

  const triggerSurveyOnSubmit = useCallback(() => trigger('submit'), [trigger]);
  const triggerSurveyOnCancel = useCallback(() => trigger('cancel'), [trigger]);

  return {
    triggerSurveyOnSubmit,
    triggerSurveyOnCancel,
  };
};
